import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import './css/eventdetails.css'; // optional, for styling
import { FaArrowLeft,  FaCalendarAlt, FaEdit, FaSave} from 'react-icons/fa'; // icons
import { MdClose , MdDelete } from "react-icons/md";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ConfirmDialog from './components/ConfirmDialog.js';
import { Button, Dialog, DialogContent, DialogActions } from '@mui/material';
import { API_URL_BASE } from './config';

const EventUpdateDetails = () => {
  //const { id } = useParams(); // Get event ID from URL
  const { event } = useLocation().state || {} ;
  const [token, setToken] = useState('');
  const [message, setMessage] = useState('');
  const [eventdetails, setEventDetails] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [dialogmessage,setDialogMessage] = useState('');
  const [dialogaction,setDialogAction] =  useState(() => () => {});
  const [editingRowId, setEditingRowId] = useState(null);
  const [editedTicket, setEditedTicket] = useState({});
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();	
  const [emailError, setEmailError] = useState('');
  const [mobileError, setMobileError] = useState('');	
  const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  const validateMobile = (val) => /^(?:06\d{8}|\+316\d{8})$/.test(val);
	
  const [formData, setFormData] = useState({
	  eventId:'',
      eventName: '',
	  eventDesc: '',
	  eventImage: '',
      organiserName: '',
      eventStartDate: '',
      eventEndDate: '',
	  address: '',
	  type : '',
	  contactemail : '',
	  contactno : '',
	  status : 'NEW'
  });

  useEffect(() => {
	const storedToken = localStorage.getItem('token');
	  if (storedToken) {
	    setToken(storedToken);
	  } else {
	    console.warn("No token found in localStorage");
		navigate("/");
	  }
	  
    if (event) {
      setFormData({
		eventId: event.eventid,
        eventName: event.name,
		eventDesc: event.description,
		eventImage: event.image,
		organiserName : event.organisername,
        eventStartDate: event.startdatetime,
        eventEndDate: event.enddatetime,
		address: event.address || '',
		type : event.type,
		contactemail : event.contactemail,
		contactno : event.contactno,
		status : event.status
      });
    } else {
		navigate("/dashboard/events")
	}
  }, [event, token]);
  
  
  useEffect(() => {
  if (!token) return; // Don't run if token is not ready

    fetch(API_URL_BASE + `/ticket.json`,{
  	method: 'POST',
  	     headers: {
  	       'Content-Type': 'application/json',
  	     },
  	     body: JSON.stringify({
  	       fetcheventdetails: {
  			   token: token,
  	           id: event.eventid
  	       }
  	     }),
  	   })
      .then(res => {
        if (!res.ok) throw new Error('Event not found');
        return res.json();
      })
      .then(data => {
        setEventDetails(data.eventdetails); // Adjust based on your actual response shape
        console.log(data.eventdetails);
      })
      .catch(err => {
        console.error('Error loading event:', err);
        setEventDetails(null);
      })
      .finally();
  }, [event, token]);
  


  const handleOkClick = () => {
    setOpen(false); // Close the dialog
  };
  
  const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
  };

  const handleDateChange = (date, field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: date ? date.getTime() : null  // epoch millis
 
    }));
  };
  
  const handleDelete = (e) => {
	e.preventDefault();
	setShowDialog(true);
	setOpen(false);
  }
  
  const handleConfirmDelete =  async (e) => {
  	console.log("Deleting event:", event);
  	setShowDialog(false);
  	e.preventDefault();
  	try {
  	const response = await fetch(API_URL_BASE + '/ticket.json', {
  				    	method: 'POST',
  				    	headers: {
  				      	'Content-Type': 'application/json',
  				    	},
  				    	body: JSON.stringify(					{
  							deleteevent : {
								token: token,
  								id  : event.eventid}
  						  })
  				  	});
  					

  	// Check if fetch succeeded (status not blocked)
  	if (!response.ok) {
  	  throw new Error(`Server error: ${response.status}`);
  	}
	const delresult = await response.json();
	console.log(delresult);
	setMessage(delresult.message);

	if (delresult && delresult.message) {
		setOpen(true);
		setDialogMessage("Event Deleted!");
		setDialogAction(() => () => navigate(`/dashboard/events/`));
	  return delresult.message; // Return eventId to caller
	  //onSuccess(result.message); 
	} else {
	  throw new Error("Event deletion failed");
	}
	
	}
	catch(e){
				setMessage(e.message || " An unexpected error occurred with Deleting event!!");
			}	
			};
    
  
  const handleSubmit =  async (e) => {
	e.preventDefault();
	try {
		
	const response = await fetch(API_URL_BASE + '/ticket.json', {
				    	method: 'POST',
				    	headers: {
				      	'Content-Type': 'application/json',
				    	},
				    	body: JSON.stringify(					{
							updateevent : {
								token: token,
								event  : {	
									eventid:formData.eventId,
									name: formData.eventName,
									description: formData.eventDesc,
									organisername :formData.organiserName,
									startdatetime: formData.eventStartDate,
									enddatetime: formData.eventEndDate,
									address:formData.address,
									image:formData.eventImage,
									type:formData.type,
									contactemail:formData.contactemail,
									contactno:formData.contactno,
									status:formData.status
									
									//ticketfee transactionfee
								}}
						  })
				  	});
					

	// Check if fetch succeeded (status not blocked)
	if (!response.ok) {
	  throw new Error(`Server error: ${response.status}`);
	}

	const result = await response.json();
	console.log(result);
	setMessage(result.message);

	if (result && result.message) {
		if(result.message == 'UPDATED') 
			{
				setOpen(true);
				setDialogMessage("Event is  Updated successfully!");
				setDialogAction(() => () => navigate(`/dashboard/events/${formData.eventId}`));
				return result.message; // Return eventId to caller
			}
			else{
				setOpen(true);
				setDialogMessage("Event update Failed!");
				setDialogAction(() => () => navigate(`/dashboard/events/${formData.eventId}`));
				return result.message; // Return eventId to caller
			}

	  //onSuccess(result.message); 
	} else {
	  throw new Error("Event Update failed");
	}

	} catch(e){
		setMessage(e.message || " An unexpected error occurred with Creating event!!");
	}	
	};
	

	const handleImageChange = (e) => {
		  const file = e.target.files && e.target.files[0];
		  if (!file) return; // no file selected
		  
		  const reader = new FileReader();
		    reader.onload = (event) => {
		      const img = new Image();
		      img.src = event.target.result;

		      img.onload = () => {
		        const canvas = document.createElement("canvas");
		        const ctx = canvas.getContext("2d");

		        // Scale down if needed
		        const MAX_WIDTH = 800;
		        const scale = Math.min(1, MAX_WIDTH / img.width);
		        canvas.width = img.width * scale;
		        canvas.height = img.height * scale;

		        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

		        let quality = 0.9;
		        let base64String = "";

		        // Try reducing quality until under 50 KB
		        do {
		          base64String = canvas
		            .toDataURL("image/jpeg", quality)
		            .split(",")[1];
		          quality -= 0.05; // reduce step by step
		        } while (base64String.length / 1024 > 50 && quality > 0.1);

		        console.log("Final size:", Math.round(base64String.length / 1024), "KB");

		        setFormData((prev) => ({
		          ...prev,
		          eventImage: base64String,
		        }));
		      }
		};

		 /* const reader = new FileReader();
		  reader.onloadend = () => {
			console.log(reader.result);
			const base64String = reader.result.split(",")[1]; // remove prefix "data:image/png;base64,"
			
		    setFormData((prev) => ({
		      ...prev,
		      eventImage: base64String, // base64 string of the image , // keep only the base64 part
		    }));
		  };*/
		  reader.readAsDataURL(file);
		};
		
  
		
		/* ******** Tickets Table edit handlers ******** */
		const handleEditClick = (ticket) => {
		  setEditingRowId(ticket.Hjid);
		  setEditedTicket({ ...ticket ,
			price: (ticket.price / 100).toFixed(2), // euros as string
		   });
		};

		const handleTicketChange = (field, value) => {
		  setEditedTicket((prev) => ({
		    ...prev,
		    [field]: value,
		  }));
		};

		const handleCancel = () => {
		  setEditingRowId(null);
		  setEditedTicket({});
		};
		
		
		const handleDeleteTicket = async (ticket) => {
			}
			
			// ── Add new ticket ──
			const [showAddTicket, setShowAddTicket] = useState(false);
			const [newTicket, setNewTicket] = useState({ name: '', price: '', capacity: '' });
			const [newTicketMessage, setNewTicketMessage] = useState('');
			const isFreePaidPrivate = formData.type?.toUpperCase();

			const handleNewTicketChange = (e) => {
				const { name, value } = e.target;
				setNewTicket((prev) => ({ ...prev, [name]: value }));
			};

			const handleAddTicket = async (e) => {
				e.preventDefault();
				try {
					const response = await fetch(API_URL_BASE + '/ticket.json', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({
							saveticket: {
								token: token,
								newticket: {
									eventid: formData.eventId,
									name: newTicket.name,
									price: isFreePaidPrivate === 'FREE' ? 0 : newTicket.price * 100,
									capacity: newTicket.capacity,
									ticketsold: 0
								}
							}
						})
					});

					if (!response.ok) throw new Error(`Server error: ${response.status}`);
					const result = await response.json();

					if (result && result.message) {
						// Refresh ticket list
						setEventDetails((prev) => ({
							...prev,
							tickets: [...(prev?.tickets || []), {
								Hjid: Date.now(), // temp id until refresh
								name: newTicket.name,
								price: isFreePaidPrivate === 'FREE' ? 0 : newTicket.price * 100,
								capacity: newTicket.capacity,
								ticketsold: 0
							}]
						}));
						setNewTicket({ name: '', price: '', capacity: '' });
						setNewTicketMessage('');
						setShowAddTicket(false);
						setOpen(true);
						setDialogMessage("Ticket added successfully!");
						setDialogAction(() => () => setOpen(false));
					} else {
						throw new Error("Adding ticket failed");
					}
				} catch (e) {
					setNewTicketMessage(e.message || "An unexpected error occurred.");
				}
			};
	

		const handleSave = async (editedTicket) => {
		  console.log("Saving ticket:", editedTicket);	

		  	try {
		  	const response = await fetch(API_URL_BASE + '/ticket.json', {
		  				    	method: 'POST',
		  				    	headers: {
		  				      	'Content-Type': 'application/json',
		  				    	},
		  				    	body: JSON.stringify({
		  							saveticket : {
		  								token : token,
		  								newticket  : {	
											hjid: editedTicket.Hjid,
		  									eventid: editedTicket.eventid,
											ticketid: editedTicket.ticketid,
		  									name : editedTicket.name,
		  									price:editedTicket.price * 100 ,
		  									capacity:editedTicket.capacity,
		  									ticketsold:0
		  								}}
		  						  })
		  				  	});
		  					

			console.log(response);
		  	// Check if fetch succeeded (status not blocked)
		  	if (!response.ok) {
		  	  throw new Error(`Server error: ${response.status}`);
		  	}

			const result = await response.json();
			console.log(result);
			setMessage(result.message);

			if (result && result.message) {
				if(result.message == 'UPDATED') 
					{
						setOpen(true);
						setDialogMessage("Ticket is  Updated successfully!");
						setDialogAction(() => () =>  {
							setOpen(false);
							navigate(`/dashboard/events/update`,{state:{event: event}});
						});
						setEditingRowId(null);
						setEditedTicket({});
						
						return result.message; // Return eventId to caller
					}
					else{
						setOpen(true);
						setDialogMessage("Ticket update Failed!");
						setDialogAction(() => () =>  {
							setOpen(false);
							navigate(`/dashboard/events/update`,{state:{event: event}});
						});
						
						setEditingRowId(null);
						setEditedTicket({});
						
						return result.message; // Return eventId to caller
					}

			  //onSuccess(result.message); 
			} else {
			  throw new Error("Ticket Update failed");
			}	    
			} catch(e){
					setMessage(e.message || " An unexpected error occurred with Creating event!!");
				}	
		  
		  // update UI state locally (optional)
		    setEventDetails((prev) => ({
		      ...prev,
		      tickets: prev.tickets.map((t) =>
		        t.Hjid === editedTicket.Hjid ? editedTicket : t
		      ),
		    } ));

		    setEditingRowId(null);
		  };	

  return (
    <div>
	<section className="main-content">
		<a className="back-arrow" onClick={() => navigate('/dashboard/events')}>
	         <span><FaArrowLeft/>  Back to Events</span>
	  	</a>
		<Dialog open={open} onClose={handleOkClick}>
		  <DialogContent>
		   	{dialogmessage}
		  </DialogContent>
		  <DialogActions style={{ justifyContent: 'center' }}>		    
		    <Button onClick={dialogaction} autoFocus>
		      OK
		    </Button>
		  </DialogActions>
		</Dialog>
		
		{showDialog && (
		        <ConfirmDialog
		          title="Confirm Delete"
		          message={`Are you sure you want to delete "${event.name}"?`}
		          onConfirm={handleConfirmDelete}
		          onCancel={() => setShowDialog(false)}
		        />
		      )}
			  
	  <div>
	          <h2>Update Event</h2>
	  		<p className="error-text">{message}</p>
	  		<div className="event-form-container">
	          <form onSubmit={handleSubmit} className="event-form">
	              <label>Event Name<span className="required-asterisk">*</span></label>
	              <input type="text" name="eventName" value={formData.eventName} onChange={handleChange}  />

				  <label>Event Description</label>
				  <input type="text" name="eventDesc" value={formData.eventDesc} onChange={handleChange}  />
				  
				  <label>Event Image</label>
				  <div style={{ display: "flex",  gap: "15px" }}>
				  {/* Optional image preview */}
				  {formData.eventImage && (
				    <img
				      src={`data:image/png;base64,${formData.eventImage}`}
				      alt="Event Preview"
				      style={{ margin: "10px", width: "50px", borderRadius: "8px" }}
				    />
				  )}
				  <input type="file" name="eventImage" accept="image/*" onChange={handleImageChange}  />
				  </div>
				  
	              <label>Organizer Name<span className="required-asterisk">*</span></label>
	              <input type="text" name="organiserName" value={formData.organiserName} onChange={handleChange}  />			
	  			
	  			<label>Event Start <span className="required-asterisk">*</span></label>				
	  			<div className="datepicker-wrapper">
	  			<DatePicker
	  				  className="styled-input"
	  			      selected={ formData.eventStartDate ? new Date(formData.eventStartDate) : formData.eventStartDate}
	  			      onChange={(date) =>handleDateChange(date, 'eventStartDate')}
	  			      showTimeSelect
	  			      dateFormat="yyyy-MM-dd'T'HH:mm"
	  				  minDate={new Date()}
	  			    />
	  				<FaCalendarAlt className="calendar-icon"/>	
	  			</div>
	  			
	  			<label>Event End<span className="required-asterisk">*</span></label>				
	  			<div className="datepicker-wrapper">
	  			<DatePicker
	  				  className="styled-input"
	  			      selected={formData.eventEndDate ? new Date(formData.eventEndDate) : formData.eventEndDate}
	  			      onChange={(date) =>handleDateChange(date, 'eventEndDate')}
	  			      showTimeSelect
	  			      dateFormat="yyyy-MM-dd'T'HH:mm"
	  				  minDate={new Date()}
	  			    />
	  				<FaCalendarAlt className="calendar-icon"/>	
	  			</div>
				  				  	
				  <label>Address<span className="required-asterisk">*</span></label>
				  <input type="text" name="address" value={formData.address} onChange={handleChange}  />	
				  <label className="event-form">Contact Email<span className="required-asterisk">*</span></label>
	  				<input type="email" name="contactemail" value={formData.contactemail} 
	  				placeholder="Contact email address for visitors"
	  				onChange={(e) => {
	  				    handleChange(e);
	  				    if (!validateEmail(e.target.value)) {
	  				      setEmailError("Please enter a valid email address");
	  				    } else {
	  				      setEmailError("");
	  				    }
	  				  }} />
	  				{emailError && <p className="error-text">{emailError}</p>}
	  				
	  				<label className="event-form">Contact Mobile<span className="required-asterisk">*</span></label>
	  				<input type="tel" name="contactno" value={formData.contactno} 
	  				placeholder="Contact mobile number for visitors 06xxxxxxxx"
	  				onChange={(e) => {
	  					handleChange(e);
	  					if (!validateMobile(e.target.value)) {
	  						setMobileError("Please enter a valid mobile no");
	  					} else {
	  						setMobileError("");
	  					}
	  					}} />
	  				{mobileError && <p className="error-text">{mobileError}</p>}			  

				    <div className="event-update-button" style={{ display: 'flex', gap: '10px'}}>
				  		<button  onClick={handleSubmit}>UPDATE Event</button>
				    	<button  onClick={handleDelete}>DELETE Event </button>
				  	</div>
	          </form>
	  		</div>
			
			<div>	 	
			<h2>Tickets</h2>
				<div className="eventdetails-table-responsive">	     
			   <table className="eventdetails-ticket-table">
			       <thead>
			           <tr>
					   		<th></th>
			               <th> Name</th>
						   <th> Price </th>
			               <th> Capacity</th>
			           </tr>
			       </thead>
			       <tbody>
				    {eventdetails?.tickets?.map((ticket) => {
						const isEditing = editingRowId === ticket.Hjid;

						    return (
						      <tr key={ticket.Hjid}>
						        <td>
						          {isEditing ? (
						            <>
									<FaSave
									  style={{ cursor: "pointer", color: "green" }}
									  onClick={() => handleSave(editedTicket)}
									  title="Save"
									/>
									  <MdClose size={20} 
									    style={{ cursor: "pointer", color: "red" }}
									    onClick={() => handleCancel(ticket)}
									    title="Cancel"
									  />
						            </>
						          ) : (
									<>
						            <FaEdit
						              style={{ cursor: "pointer", color: "#1E3A8A" }}
						              onClick={() => handleEditClick(ticket)}
						              title="Edit Ticket"
						            />
									{/*<MdDelete
									        size={20}
									        style={{ cursor: "pointer", color: "crimson" }}
									        onClick={() => handleDeleteTicket(ticket)}
									        title="Delete Ticket"
									      />*/}
									</>		  
						          )}
						        </td>

						        <td>
						          {isEditing ? (
						            <input
						              value={editedTicket.name}
						              onChange={(e) =>
						                setEditedTicket({ ...editedTicket, name: e.target.value })
						              }
						            />
						          ) : (
						            ticket.name
						          )}
						        </td>

						        <td>
						          {isEditing ? (
						            <input
						              type="number"
						              value={(editedTicket.price)}
						              onChange={(e) =>
						                setEditedTicket({ ...editedTicket, price: e.target.value })
						              }
						            />
						          ) : (
						            <>€ {(ticket.price / 100).toFixed(2)}</>
						          )}
						        </td>

						        <td>
						          {isEditing ? (
						            <input
						              type="number"
						              value={editedTicket.capacity}
						              onChange={(e) =>
						                setEditedTicket({ ...editedTicket, capacity: e.target.value })
						              }
						            />
						          ) : (
						            ticket.capacity
						          )}
						        </td>
						      </tr>
						    );
					 }
				 )}	   
			       </tbody>
			   </table>
			 	</div>
				
				 </div>
				 
			 
	      </div>  	  

	  </section>
    </div>
  );
};

export default EventUpdateDetails;
